/**
 * Web stub — Metro picks this over `IncallSelfView.tsx` on the web target so
 * `react-native-agora` (native-only) never reaches the bundler. The web
 * surface for the in-call screen is the hosted `meet.html` room; this stub
 * exists purely so the web build of the Expo app stays healthy.
 */
import React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';

interface IncallSelfViewProps {
  cameraEnabled: boolean;
  large?: boolean;
  firstName?: string;
  avatarUrl?: string | null;
}

const BUNKER = '#151515';
const CONCORD = '#7E7D75';
const BLUE_BLUMINE = '#015480';
const BALTIC_SEA = '#252525';

export default function IncallSelfView({
  large = false,
  firstName,
  avatarUrl,
}: IncallSelfViewProps) {
  const initial = (firstName?.trim()?.[0] ?? '').toUpperCase();
  const cardSize = large
    ? { width: 160, height: 200 }
    : { width: 100, height: 140 };
  const avatarSize = large ? 88 : 40;
  const avatarRadius = large ? 64 : 20;

  return (
    <View style={[styles.card, cardSize]}>
      <View style={[styles.offFill, { backgroundColor: BUNKER }]}>
        <View
          style={[
            styles.avatarWrap,
            {
              width: avatarSize,
              height: avatarSize,
              borderRadius: avatarRadius,
              backgroundColor: BLUE_BLUMINE,
            },
          ]}
        >
          {avatarUrl ? (
            <Image
              source={{ uri: avatarUrl }}
              style={{
                width: avatarSize,
                height: avatarSize,
                borderRadius: avatarRadius,
              }}
            />
          ) : initial ? (
            <Text
              style={[
                styles.avatarInitial,
                { fontSize: large ? 36 : 18, lineHeight: large ? 40 : 22 },
              ]}
            >
              {initial}
            </Text>
          ) : null}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 24,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: CONCORD,
    backgroundColor: BUNKER,
  },
  offFill: { flex: 1, alignItems: 'center', justifyContent: 'center' },
  avatarWrap: {
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: BALTIC_SEA,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarInitial: { color: '#FFFFFF', fontFamily: 'Sentient-Regular' },
});
